<template>
  <van-image-preview
    v-model="show"
    :images="images"
    @change="onChange"
    :show-index="false"
    :max-zoom="1"
    :min-zoom="1"
  ></van-image-preview>
</template>

<script>
import { ImagePreview } from "vant";
import "vant/lib/image-preview/style";

export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      show: true,
      images: [
        "https://img0.baidu.com/it/u=4076493291,331486562&fm=26&fmt=auto",
        "https://img0.baidu.com/it/u=4076493291,331486562&fm=26&fmt=auto",
        "https://img0.baidu.com/it/u=4076493291,331486562&fm=26&fmt=auto",
        "https://img0.baidu.com/it/u=4076493291,331486562&fm=26&fmt=auto",
        "https://img0.baidu.com/it/u=4076493291,331486562&fm=26&fmt=auto",
        "https://img0.baidu.com/it/u=4076493291,331486562&fm=26&fmt=auto",
        "https://img0.baidu.com/it/u=4076493291,331486562&fm=26&fmt=auto",
        "https://img0.baidu.com/it/u=4076493291,331486562&fm=26&fmt=auto",
      ],
    };
  },
  methods: {
    onChange(index) {
      console.log(index);
    },
  },
};
</script>

<style>
</style>